export default () => ({ state: {}});